import PropTypes from "prop-types";
import { useEffect } from "react";

import { Controller, useFormContext } from "react-hook-form";

import { Paper } from "@mui/material";
import Grid from "@mui/material/Grid";

import { AllOutletsSelect, OutletRoleEnum, UserOutletsSelect } from "@/features/outlets";
import { CustomDatePicker } from "@/features/ui";
import { OutletWarehouseSelect } from "@/features/warehouses";

export const GeneralInformationSection = ({ disableBuyerSeller = false }) => {
  const { watch, control, setValue } = useFormContext();

  const seller = watch("seller");

  // Only reset warehouse in create mode when seller changes
  useEffect(() => {
    if (!disableBuyerSeller && seller) {
      setValue("warehouse", null);
    }
  }, [seller, setValue, disableBuyerSeller]);

  return (
    <Paper sx={{ p: 2.5, borderRadius: 2 }}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Controller
            control={control}
            name="buyer"
            render={({ field, fieldState }) => (
              <AllOutletsSelect
                value={field.value}
                onChange={field.onChange}
                allowedRoles={[OutletRoleEnum.RETAIL]}
                disabled={disableBuyerSeller}
                TextFieldProps={{
                  label: "Pelanggan (Outlet Retail)",
                  required: true,
                  error: fieldState.invalid,
                  helperText: fieldState.error?.message,
                }}
              />
            )}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Controller
            control={control}
            name="seller"
            render={({ field, fieldState }) => (
              <UserOutletsSelect
                value={field.value}
                onChange={field.onChange}
                disabled={disableBuyerSeller}
                allowedRoles={[OutletRoleEnum.HUB]}
                TextFieldProps={{
                  label: "Pemasok",
                  required: true,
                  error: fieldState.invalid,
                  helperText: fieldState.error?.message,
                }}
              />
            )}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Controller
            control={control}
            name="warehouse"
            render={({ field, fieldState }) => (
              <OutletWarehouseSelect
                value={field.value}
                onChange={field.onChange}
                disabled={!seller || disableBuyerSeller}
                outletId={seller?.id}
                TextFieldProps={{
                  label: "Gudang Pemasok",
                  required: true,
                  error: fieldState.invalid,
                  helperText: fieldState.error?.message,
                  InputProps: {
                    placeholder: "Pilih Gudang",
                  },
                }}
              />
            )}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Controller
            name="transactionDate"
            control={control}
            render={({ field, fieldState }) => (
              <CustomDatePicker
                value={field.value}
                onChange={field.onChange}
                required
                label="Tanggal Transaksi"
                error={fieldState.error}
                helperText={fieldState.error?.message}
                InputProps={{
                  disableFuture: true,
                }}
              />
            )}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

GeneralInformationSection.propTypes = {
  disableBuyerSeller: PropTypes.bool,
};
